import {Component, Inject, LOCALE_ID} from '@angular/core';
import {DatePipe} from '@angular/common';
import {FilterFieldResponseEnabled} from '../../../../../common/services/responses/filter-field-response-enabled.model';
import {ResponseStateGestModel} from '../../../../../common/components/form/response-states/response-state-gest-model';
import {FilterEnableComponent} from '../../common/filter-enable.component';

@Component({
  selector: 'app-filter-response-enabled',
  templateUrl: '../../common/filter-enable.component.html',
  styleUrls: ['../../common/filter-enable.component.scss']
})
export class FilterResponseEnabledComponent extends FilterEnableComponent {
  constructor(@Inject(LOCALE_ID) public locale: string) {
    super();
  }
  getValue(filter: FilterFieldResponseEnabled) {
    if (filter.type === 'dt_created' || filter.type === 'dt_updated') {
      const dp: DatePipe = new DatePipe(this.locale);
      return dp.transform(`${filter.value}`, 'dd/MM/yyyy');
    }
    if (filter.type === 'by_instructions__state') {
      const values = filter.value as ResponseStateGestModel[];
      return values
        .reduce((acc: string, currentValue: ResponseStateGestModel, idx) =>
          idx === 0 ? currentValue.label.toLowerCase() : `${acc} OU ${currentValue.label.toLowerCase()}`, '');
    }
    return '';
  }
}
